import React, {Component, Fragment, h} from "preact";
import {Card, CF, RE} from "../../_common/layout";
import {connect} from "react-redux";
import {AppPage} from "../../_common/components/app-page";
import {t} from "../../_i18n";
import {acceptPrivacyPolicy, fetchCandidate} from "../../_rx/jobs/actions";
import {Checkbox} from "../../_common/forms/components/Checkbox/Checkbox";


let TermsView = class extends Component {

    state = {
        checked : false,
        buttonDisable: false
    }

    handleChecked = (value) => {
        this.setState({checked: value})
    }

    handleSubmit = async () => {
        this.setState({buttonDisable: true})
        const userId = this.props.auth.loggedUser.id
        const {history} = this.props
        await this.props.acceptPrivacyPolicy()
        await this.props.fetchCandidate()
        history.push('/jobs')
    }

    render() {
        return <CF className='max-width'>
            <Card smOnly={false}>
                <span className='font-18'>Para empezar a utilizar la bolsa de trabajo de ILERNA, lee y acepta la Política de Privacidad.</span>
                <Card className='m-top background-info font-18 p-all'>
                    <span className='font-medium'>INFORMACIÓN PROTECCIÓN DE DATOS DE ILERNA</span>
                    <ul>
                        <li>
                            <span className='font-medium'>FINALIDADES:</span> Disponer de tu CV para gestionar tu acceso a la Bolsa de Trabajo de ILERNA, donde podrás acceder a ofertas de empleo de nuestras empresas/entidades colaboradoras.
                        </li>
                        <li className='m-top'>
                            <span className='font-medium'>DERECHOS:</span> Puedes retirar tu consentimiento en cualquier momento, así como acceder, rectificar, suprimir tus datos y demás derechos en <span className='t-underline'>ilerna@delegado-datos.com</span>.
                        </li>
                    </ul>

                    <span className='m-top'>Información Adicional: <a href='https://www.ilerna.es/es/content/politica-de-privacidad-19' className='t-underline'>Política de Privacidad</a>.</span>
                </Card>

                <div className='m-top-x2 d-flex m-bottom font-18'>
                    <Checkbox
                        onChange={this.handleChecked}
                        value={this.state.checked}
                        label={
                            <span>
                                He leído y acepto la <a href='https://www.ilerna.es/es/content/politica-de-privacidad-19' >Política de Privacidad</a>.
                            </span>
                        }
                    />

                </div>
                <button className='btn btn-primary m-top full-width sm-no-full-width' disabled={!this.state.checked || this.state.buttonDisable} onClick={this.handleSubmit}>ACEPTAR Y EMPEZAR</button>
            </Card>
        </CF>
    }
}

TermsView = connect(
    (props)=>({...props}), {acceptPrivacyPolicy, fetchCandidate})(TermsView);

const TermsPage = (props) =>
    <AppPage
        name="terms"
        title={t('Bolsa de trabajo')}
        className="max-width">
        <TermsView {...props}/>
    </AppPage>
;

export default TermsPage;
